import React from "react";
import styles from "./stylesComponent/Card.module.css";
import { useState, useEffect  } from "react";
import {Link} from 'react-router-dom';

const Card = ({ producto }) => {

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';
 
    const [tutorContenido, setTutorContenido] = useState({ Nombre: "", Apellidos: "" });
    
    const getTutorContenido = async(id) => {
        try{
            const response = await fetch(`${baseUrl}/api/users/${id}`, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            });
            if (!response.ok) {
                throw new Error("Usuario no encontrado");
            }

            const usuario = await response.json();
            setTutorContenido(usuario);
            
        } catch (error) {
            console.error("Error al obtener el tutor" + error.message);
        }
    };
    
    useEffect(() => {
        if(producto.Id_Tutor) getTutorContenido(producto.Id_Tutor);
    }, [producto.Id_Tutor]);

 
    return(
        <Link to={{ pathname: `/detalleContenido/${producto._id}`, state: { producto: producto, tutor: tutorContenido } }} >
            <div className={styles.card}>
                <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={producto.Nombre} />
                <div className={styles.data}>
                    <p title={producto.Nombre}>{producto.Nombre}</p>
                    <div className={styles.infoInferior}>
                        <p>{tutorContenido.Nombre} {tutorContenido.Apellidos}</p>
                        <div className={styles.tematicas} title={producto.Tematica?.join(", ")}>
                            <span>{producto.Tematica?.join(", ")}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default Card;